import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverAcknowledge extends Layout {
	buttonAcknowledge: Button;
	buttonRefresh: Button;
	labelInstructions: Label;
	sourceAcknowledge: DataSource;
	tableDriverAck: Table;
}
